import { TemplateTypeDataEnum } from '@ysura/common';

import { createEnumMapperFunction } from '@/services/graphql/mappers/utils';
import { TemplateType } from '@/services/graphql/types';

export const mapperTemplateTypeDataEnum = createEnumMapperFunction(
  TemplateType,
  TemplateTypeDataEnum
);
